import NoResultsFound from "./NoResultsFound";
import ResultsRow from "./ResultsRow";

import "./ResultsTable.css";

const ResultsTable = ({ data, message }) => {
  return (
    <table>
      <tbody>
        <tr>
          <th>APPLICATION ID</th>
          <th>APPLICANT</th>
          <th>DATE RECEIVED</th>
          <th>DECISION</th>
          <th>AMOUNT APPLIED</th>
          <th>AMOUNT APPROVED</th>
          <th>APPLIED FOR</th>
          <th>FUNDING ROUND</th>
        </tr>

        {data && data.length > 0 ? (
          data.map((d, index) => (
            <ResultsRow
              key={d.application_id}
              className={index % 2 === 0 ? "grid-bg" : ""}
              data={d}
            />
          ))
        ) : (
          <NoResultsFound message={message} />
        )}
      </tbody>
    </table>
  );
};

export default ResultsTable;
